.body {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
  min-width: min(560px, 80vw);
}

.warning {
  margin: 0;
  padding: var(--sp-4) var(--sp-5);
  border: var(--bw) solid var(--warn-border);
  border-radius: var(--radius);
  background: var(--warn-bg);
  color: var(--warn);
  box-shadow: var(--glow-warn);
  font-size: var(--fs-sm);
  line-height: 1.4;
}

.muted {
  margin: 0;
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.summary {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-6);
  font-size: var(--fs-sm);
  color: var(--text-2);
}

.variants {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
  margin: 0;
  padding: 0;
  list-style: none;
}

.variant {
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  padding: var(--sp-4) var(--sp-5);
  background: var(--surface-sunken);
}

.variantName {
  display: block;
  font-size: var(--fs-md);
  font-weight: 600;
  color: var(--text);
  margin-bottom: var(--sp-3);
}

.segments {
  margin: 0;
  padding-left: var(--sp-7);
  color: var(--text-2);
  font-size: var(--fs-sm);
  line-height: 1.6;
}

.raw {
  max-height: 40vh;
  overflow: auto;
  margin: 0;
  padding: var(--sp-5);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  background: var(--surface-sunken);
  color: var(--text-2);
  font-family: var(--font-mono);
  font-size: var(--fs-xs);
  line-height: 1.5;
}
